import React from 'react';
import { useTranslation } from 'react-i18next';

import defaultLogo from '../../../assets/logo.svg';
import socialLogo from '../../../assets/logo-social.svg';
import chatLogo from '../../../assets/logo-chat.svg';
import { Image, Link } from './styles';

const logos = { social: socialLogo, chat: chatLogo };
const logo = logos[process.env.REACT_APP_PRODUCT_KEY] || defaultLogo;

export default function Logo({ className, fullWidth, imgComponent: ImageComponent = Image }) {
  const { t } = useTranslation();

  return (
    <Link fullWidth={fullWidth} className={className} href="/" color="secondary">
      <ImageComponent src={logo} alt={t('logo.title')} />
    </Link>
  );
}
